import { lsApiService } from 'ls-vue-common';

export const CURRENT_CUST_TOS_VERSION = 'cust-v2023-11';
export default {
    constants: {
        ALREADY_ACCEPTED: 'The current terms of service have already been accepted.',
    },

    /**
     * Accept Terms of Service
     * @param {number} customerId
     * @return {Promise}
     */
    acceptToS(customerId) {
        return lsApiService.request({
            method: 'POST',
            route: `/customers/${customerId}/terms-of-service/accept`,
            payload: {
                tos_version: CURRENT_CUST_TOS_VERSION,
            },
        });
    },
};
